import React from "react";
import "./ClientSkeleton.css";

const ClientManagementSkeletonDemo = () => {
  return (
    <div className='storelense-client-mgmt-skeleton-container'>
      {/* Header Section */}
      <div className='storelense-client-mgmt-skeleton-header'>
        <div className='storelense-client-mgmt-skeleton-header-left'>
          <div className='storelense-client-mgmt-skeleton-title'></div>
          <div className='storelense-client-mgmt-skeleton-subtitle'></div>
        </div>
        <div className='storelense-client-mgmt-skeleton-btn'></div>
      </div>

      {/* Search Bar */}
      <div className='storelense-client-mgmt-skeleton-search'></div>

      {/* Filter Tabs */}
      <div className='storelense-client-mgmt-skeleton-tabs'>
        <div className='storelense-client-mgmt-skeleton-tab storelense-client-mgmt-skeleton-tab-active'></div>
        <div className='storelense-client-mgmt-skeleton-tab'></div>
        <div className='storelense-client-mgmt-skeleton-tab'></div>
        <div className='storelense-client-mgmt-skeleton-tab'></div>
        <div className='storelense-client-mgmt-skeleton-tab'></div>
      </div>

      {/* Client Cards */}
      <div className='storelense-client-mgmt-skeleton-cards'>
        {[1, 2, 3, 4].map((cardIndex) => (
          <div key={cardIndex} className='storelense-client-mgmt-skeleton-card'>
            {/* Card Header */}
            <div className='storelense-client-mgmt-skeleton-card-header'>
              <div className='storelense-client-mgmt-skeleton-avatar'></div>
              <div className='storelense-client-mgmt-skeleton-card-header-info'>
                <div className='storelense-client-mgmt-skeleton-card-title'></div>
                <div className='storelense-client-mgmt-skeleton-card-category'></div>
              </div>
              <div className='storelense-client-mgmt-skeleton-badge'></div>
            </div>

            {/* Contact Info */}
            <div className='storelense-client-mgmt-skeleton-contact'>
              <div className='storelense-client-mgmt-skeleton-contact-item'></div>
              <div className='storelense-client-mgmt-skeleton-contact-item'></div>
            </div>

            {/* Stats Grid */}
            <div className='storelense-client-mgmt-skeleton-stats'>
              {[1, 2, 3, 4].map((statIndex) => (
                <div key={statIndex} className='storelense-client-mgmt-skeleton-stat'>
                  <div className='storelense-client-mgmt-skeleton-stat-label'></div>
                  <div className='storelense-client-mgmt-skeleton-stat-value'></div>
                </div>
              ))}
            </div>

            {/* Action Buttons */}
            <div className='storelense-client-mgmt-skeleton-actions'>
              {[1, 2, 3, 4].map((btnIndex) => (
                <div key={btnIndex} className='storelense-client-mgmt-skeleton-action-btn'></div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ClientManagementSkeletonDemo;

{
  /* <body>
    <div class="storelense-client-mgmt-skeleton-container">
        <!-- Header Section -->
        <div class="storelense-client-mgmt-skeleton-header">
            <div class="storelense-client-mgmt-skeleton-header-left">
                <div class="storelense-client-mgmt-skeleton-title"></div>
                <div class="storelense-client-mgmt-skeleton-subtitle"></div>
            </div>
            <div class="storelense-client-mgmt-skeleton-btn"></div>
        </div>

        <!-- Search Bar -->
        <div class="storelense-client-mgmt-skeleton-search"></div>

        <!-- Filter Tabs -->
        <div class="storelense-client-mgmt-skeleton-tabs">
            <div class="storelense-client-mgmt-skeleton-tab storelense-client-mgmt-skeleton-tab-active"></div>
            <div class="storelense-client-mgmt-skeleton-tab"></div>
            <div class="storelense-client-mgmt-skeleton-tab"></div>
            <div class="storelense-client-mgmt-skeleton-tab"></div>
            <div class="storelense-client-mgmt-skeleton-tab"></div>
        </div>

        <!-- Client Cards -->
        <div class="storelense-client-mgmt-skeleton-cards">
            <!-- Card 1 -->
            <div class="storelense-client-mgmt-skeleton-card">
                <!-- Card Header -->
                <div class="storelense-client-mgmt-skeleton-card-header">
                    <div class="storelense-client-mgmt-skeleton-avatar"></div>
                    <div class="storelense-client-mgmt-skeleton-card-header-info">
                        <div class="storelense-client-mgmt-skeleton-card-title"></div>
                        <div class="storelense-client-mgmt-skeleton-card-category"></div>
                    </div>
                    <div class="storelense-client-mgmt-skeleton-badge"></div>
                </div>

                <!-- Contact Info -->
                <div class="storelense-client-mgmt-skeleton-contact">
                    <div class="storelense-client-mgmt-skeleton-contact-item"></div>
                    <div class="storelense-client-mgmt-skeleton-contact-item"></div>
                </div>

                <!-- Stats Grid -->
                <div class="storelense-client-mgmt-skeleton-stats">
                    <div class="storelense-client-mgmt-skeleton-stat">
                        <div class="storelense-client-mgmt-skeleton-stat-label"></div>
                        <div class="storelense-client-mgmt-skeleton-stat-value"></div>
                    </div>
                    <div class="storelense-client-mgmt-skeleton-stat">
                        <div class="storelense-client-mgmt-skeleton-stat-label"></div>
                        <div class="storelense-client-mgmt-skeleton-stat-value"></div>
                    </div>
                    <div class="storelense-client-mgmt-skeleton-stat">
                        <div class="storelense-client-mgmt-skeleton-stat-label"></div>
                        <div class="storelense-client-mgmt-skeleton-stat-value"></div>
                    </div>
                    <div class="storelense-client-mgmt-skeleton-stat">
                        <div class="storelense-client-mgmt-skeleton-stat-label"></div>
                        <div class="storelense-client-mgmt-skeleton-stat-value"></div>
                    </div>
                </div>

                <!-- Action Buttons -->
                <div class="storelense-client-mgmt-skeleton-actions">
                    <div class="storelense-client-mgmt-skeleton-action-btn"></div>
                    <div class="storelense-client-mgmt-skeleton-action-btn"></div>
                    <div class="storelense-client-mgmt-skeleton-action-btn"></div>
                    <div class="storelense-client-mgmt-skeleton-action-btn"></div>
                </div>
            </div>

            <!-- Card 2 -->
            <div class="storelense-client-mgmt-skeleton-card">
                <div class="storelense-client-mgmt-skeleton-card-header">
                    <div class="storelense-client-mgmt-skeleton-avatar"></div>
                    <div class="storelense-client-mgmt-skeleton-card-header-info">
                        <div class="storelense-client-mgmt-skeleton-card-title"></div>
                        <div class="storelense-client-mgmt-skeleton-card-category"></div>
                    </div>
                    <div class="storelense-client-mgmt-skeleton-badge"></div>
                </div>
                <div class="storelense-client-mgmt-skeleton-contact">
                    <div class="storelense-client-mgmt-skeleton-contact-item"></div>
                    <div class="storelense-client-mgmt-skeleton-contact-item"></div>
                </div>
                <div class="storelense-client-mgmt-skeleton-stats">
                    <div class="storelense-client-mgmt-skeleton-stat">
                        <div class="storelense-client-mgmt-skeleton-stat-label"></div>
                        <div class="storelense-client-mgmt-skeleton-stat-value"></div>
                    </div>
                    <div class="storelense-client-mgmt-skeleton-stat">
                        <div class="storelense-client-mgmt-skeleton-stat-label"></div>
                        <div class="storelense-client-mgmt-skeleton-stat-value"></div>
                    </div>
                    <div class="storelense-client-mgmt-skeleton-stat">
                        <div class="storelense-client-mgmt-skeleton-stat-label"></div>
                        <div class="storelense-client-mgmt-skeleton-stat-value"></div>
                    </div>
                    <div class="storelense-client-mgmt-skeleton-stat">
                        <div class="storelense-client-mgmt-skeleton-stat-label"></div>
                        <div class="storelense-client-mgmt-skeleton-stat-value"></div>
                    </div>
                </div>
                <div class="storelense-client-mgmt-skeleton-actions">
                    <div class="storelense-client-mgmt-skeleton-action-btn"></div>
                    <div class="storelense-client-mgmt-skeleton-action-btn"></div>
                    <div class="storelense-client-mgmt-skeleton-action-btn"></div>
                    <div class="storelense-client-mgmt-skeleton-action-btn"></div>
                </div>
            </div>

            <!-- Card 3 -->
            <div class="storelense-client-mgmt-skeleton-card">
                <div class="storelense-client-mgmt-skeleton-card-header">
                    <div class="storelense-client-mgmt-skeleton-avatar"></div>
                    <div class="storelense-client-mgmt-skeleton-card-header-info">
                        <div class="storelense-client-mgmt-skeleton-card-title"></div>
                        <div class="storelense-client-mgmt-skeleton-card-category"></div>
                    </div>
                    <div class="storelense-client-mgmt-skeleton-badge"></div>
                </div>
                <div class="storelense-client-mgmt-skeleton-contact">
                    <div class="storelense-client-mgmt-skeleton-contact-item"></div>
                    <div class="storelense-client-mgmt-skeleton-contact-item"></div>
                </div>
                <div class="storelense-client-mgmt-skeleton-stats">
                    <div class="storelense-client-mgmt-skeleton-stat">
                        <div class="storelense-client-mgmt-skeleton-stat-label"></div>
                        <div class="storelense-client-mgmt-skeleton-stat-value"></div>
                    </div>
                    <div class="storelense-client-mgmt-skeleton-stat">
                        <div class="storelense-client-mgmt-skeleton-stat-label"></div>
                        <div class="storelense-client-mgmt-skeleton-stat-value"></div>
                    </div>
                    <div class="storelense-client-mgmt-skeleton-stat">
                        <div class="storelense-client-mgmt-skeleton-stat-label"></div>
                        <div class="storelense-client-mgmt-skeleton-stat-value"></div>
                    </div>
                    <div class="storelense-client-mgmt-skeleton-stat">
                        <div class="storelense-client-mgmt-skeleton-stat-label"></div>
                        <div class="storelense-client-mgmt-skeleton-stat-value"></div>
                    </div>
                </div>
                <div class="storelense-client-mgmt-skeleton-actions">
                    <div class="storelense-client-mgmt-skeleton-action-btn"></div>
                    <div class="storelense-client-mgmt-skeleton-action-btn"></div>
                    <div class="storelense-client-mgmt-skeleton-action-btn"></div>
                    <div class="storelense-client-mgmt-skeleton-action-btn"></div>
                </div>
            </div>

            <!-- Card 4 -->
            <div class="storelense-client-mgmt-skeleton-card">
                <div class="storelense-client-mgmt-skeleton-card-header">
                    <div class="storelense-client-mgmt-skeleton-avatar"></div>
                    <div class="storelense-client-mgmt-skeleton-card-header-info">
                        <div class="storelense-client-mgmt-skeleton-card-title"></div>
                        <div class="storelense-client-mgmt-skeleton-card-category"></div>
                    </div>
                    <div class="storelense-client-mgmt-skeleton-badge"></div>
                </div>
                <div class="storelense-client-mgmt-skeleton-contact">
                    <div class="storelense-client-mgmt-skeleton-contact-item"></div>
                    <div class="storelense-client-mgmt-skeleton-contact-item"></div>
                </div>
                <div class="storelense-client-mgmt-skeleton-stats">
                    <div class="storelense-client-mgmt-skeleton-stat">
                        <div class="storelense-client-mgmt-skeleton-stat-label"></div>
                        <div class="storelense-client-mgmt-skeleton-stat-value"></div>
                    </div>
                    <div class="storelense-client-mgmt-skeleton-stat">
                        <div class="storelense-client-mgmt-skeleton-stat-label"></div>
                        <div class="storelense-client-mgmt-skeleton-stat-value"></div>
                    </div>
                    <div class="storelense-client-mgmt-skeleton-stat">
                        <div class="storelense-client-mgmt-skeleton-stat-label"></div>
                        <div class="storelense-client-mgmt-skeleton-stat-value"></div>
                    </div>
                    <div class="storelense-client-mgmt-skeleton-stat">
                        <div class="storelense-client-mgmt-skeleton-stat-label"></div>
                        <div class="storelense-client-mgmt-skeleton-stat-value"></div>
                    </div>
                </div>
                <div class="storelense-client-mgmt-skeleton-actions">
                    <div class="storelense-client-mgmt-skeleton-action-btn"></div>
                    <div class="storelense-client-mgmt-skeleton-action-btn"></div>
                    <div class="storelense-client-mgmt-skeleton-action-btn"></div>
                    <div class="storelense-client-mgmt-skeleton-action-btn"></div>
                </div>
            </div>
        </div>
    </div>
</body> */
}
